import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'

export default function ReciptPrintingCompatibilityModeSelector({ value, onChange }) {
  return (
    <div>
      <FormControlLabel
        label="Use compatibility mode"
        control={
          <Checkbox
            checked={value}
            onChange={(e) => {
              onChange(e.target.checked)
            }}
          />
        }
      />
    </div>
  )
}
